module.exports = __webpack_public_path__ + "assets/img/rechangeItemActive.4de7b6a4.svg";